<template>
  <v-container fluid ma-0 pa-0 >
    <v-layout justify-center row wrap class="trackDutyLayout">
      <v-flex xs12 ma-0 pa-0>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm6 pa-0>
            <h1 class="display-1 mt-2 ml-2">Track Duty Roster</h1>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm1 text-xs-right pa-0>
            <v-btn color="transparent" fab depressed small @click="reloadUi()">
              <v-icon size="30">refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider/>
        <v-progress-linear v-if="isLoading" color="orange" class="ma-0" indeterminate />
        <v-layout row wrap justify-center>
          <v-flex xs12 pa-0>
            <v-tabs v-model="yeartab" grow>
              <v-tab v-for="(year, i) in years" :key="i" active-class="active">
                {{year}}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="yeartab">
              <v-tab-item v-for="(year, i) in years" :key="i">
                <v-divider/>
                <v-tabs v-model="monthtab" grow>
                  <v-tab v-for="(month, ii) in months" :key="ii" active-class="active" @click="loadMonthUi(i, ii)">
                    {{month}}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="monthtab">
                  <v-tab-item v-for="(month, ii) in months" :key="ii">
                    <v-divider/>
                    <MonthRoster :ref="setMonthRef(i, ii)" :key="componentKey" :currentYear=year :currentMonth=ii />
                  </v-tab-item>
                </v-tabs-items>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import TestMembers from '@/data/uncreated-full.json'
import MonthRoster from '@/components/MonthRoster'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TrackDuty',
  components: {
    MonthRoster
  },
  computed: {
    setyeartab () {
      if (!this.years) return 0
      return this.years.indexOf(this.currentYear)
    },
    setmonthtab () {
      if (!this.months) return 0
      return this.currentMonth
    },
    ...mapGetters({
      roster: 'getRoster'
    }),
    hasRoster () {
      if (!this.years || this.years.length <= 0) return false
      return (this.roster !== undefined && this.roster !== null)
    }
  },
  methods: {
    ...mapActions([
      'loadRoster',
      'getMembers'
    ]),
    forceUpdate: function () {
      this.componentKey += 1
    },
    getMonth: function (month) {
      return this.months[month - 1]
    },
    createYearList: async function () {
      let start = new Date('01-01-2019').getFullYear()
      let end = new Date().getFullYear() + 1

      let years = []
      let x = start
      // Generate a year tab for every year between 2019 and now + 1 year
      for (var i = start; i <= end; i += 1) {
        years.push(x)
        x += 1
      }

      return years
    },
    async loadUi () {
      if (this.isLoading) return
      this.isLoading = true
      this.years = await this.createYearList()
      this.yeartab = this.setyeartab
      this.monthtab = this.setmonthtab

      await this.loadRoster()
      this.getMembers()
      this.loadMonthUi(this.yeartab, this.monthtab)
      this.isLoading = false
    },
    async reloadUi () {
      if (this.isLoading) return
      this.isLoading = true
      await this.loadRoster()
      this.getMembers()
      this.loadMonthUi(this.yeartab, this.monthtab)
      this.isLoading = false
    },
    loadMonthUi (year, month) {
      const component = this.$refs[`monthRoster-${year}-${month}`][0]
      component.loadMonthRoster()
    },
    setMonthRef (year, month) {
      return `monthRoster-${year}-${month}`
    }
  },
  data () {
    return {
      months: ['January', 'February', 'March', 'Apil', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      yeartab: null,
      monthtab: null,
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      active: null,
      componentKey: 0,
      isLoading: false,
      years: []
    }
  },
  mounted () {
    this.loadUi()
  }
}
</script>
<style>
  em.inactive {
    color: orange;
  }
  em.active {
    color: green;
  }

  .trackDutyLayout {
    margin-bottom: 100px;
  }
</style>
